import { EventTarget } from "./eventTarget";
export const NavigationEmitter = new EventTarget();
export default NavigationEmitter;
